/**
 * Classic Feather has no "languages" icon. This SVG matches Feather/Lucide style
 * so the sidebar language selector can use <i-feather name="languages">.
 */
export const Languages =
  '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="feather feather-languages" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
  '<path d="m5 8 6 6"></path>' +
  '<path d="m4 14 6-6 2-3"></path>' +
  '<path d="M2 5h12"></path>' +
  '<path d="M7 2h1"></path>' +
  '<path d="m22 22-5-10-5 10"></path>' +
  '<path d="M14 18h6"></path>' +
  '</svg>';
